import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { stepsInOrder } from '../../constants';

export const useStepIndex = () => {
	const cancellationState = useAppSelector((state) => state.cancellation);
	const stepCeiling = cancellationState.stepCeiling;
	const stepIndex = stepsInOrder.indexOf(stepCeiling!);
	return stepIndex;
};
